import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { SharedModule } from '@shared/shared.module';
import { AccountLayoutComponent } from './account-layout/account-layout.component';
import { AccountRoutingModule } from './account-routing.module';
import { AccountService } from './account.service';
import { AccountComponent } from './account/account.component';
import { PasswordResetPolicyComponent } from './account/password-reset/password-reset-policy.component';
import { TwoFactorAuthComponent } from './account/two-factor-auth/two-factor-auth.component';
import { BillingComponent } from './billing/billing.component';
import { InvoicesComponent } from './billing/invoices/invoices.component';
import { PaymentMethodComponent } from './billing/payment-method/payment-method.component';
import { PaymentComponent } from './billing/payment/payment.component';
import { PlanSelectionComponent } from './billing/plan-selection/plan-selection.component';
import { ConnectionFolderSelectComponent } from './connections/connection-folder-select/connection-folder-select.component';
import { ConnectionsComponent } from './connections/connections.component';
import { E2eEncryptionModalComponent } from './e2e-encryption-modal/e2e-encryption-modal.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { Authenticator2faComponent } from './profile/authenticator2fa/authenticator2fa.component';
import { BackupCodesComponent } from './profile/backup-codes/backup-codes.component';
import { ProfileComponent } from './profile/profile.component';
import { Verify2faComponent } from './profile/verify2fa/verify2fa.component';
import { UsersComponent } from './users/users.component';

@NgModule({
  imports: [
    CommonModule,
    AccountRoutingModule,
    SharedModule,
    MatTreeModule,
    MatIconModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatRadioModule,
    MatSnackBarModule
  ],
  providers: [AccountService],
  declarations: [
    AccountLayoutComponent,
    AccountComponent,
    ProfileComponent,
    UsersComponent,
    ConnectionsComponent,
    BillingComponent,
    PaymentComponent,
    PlanSelectionComponent,
    ConnectionFolderSelectComponent,
    PaymentMethodComponent,
    InvoicesComponent,
    Verify2faComponent,
    Authenticator2faComponent,
    BackupCodesComponent,
    PreferencesComponent,
    PasswordResetPolicyComponent,
    E2eEncryptionModalComponent,
    TwoFactorAuthComponent
  ],
  exports: [E2eEncryptionModalComponent, Authenticator2faComponent, Verify2faComponent]
})
export class AccountModule {}
